export default {
  voice: 'Speech',
  image: 'Image',
  text: 'Text',
  video: 'Video',
  voiceCut: 'Speech cut',
  voiceCutNote: 'Intercept the audio segment from long audio as required',
  voiceTags: 'Speech annotation',
  voiceTagsNote: 'Add tags to speech',
  voiceEdit: 'Speech transcription',
  voiceEditNote: 'Dictate the audio',
  imageWhole: 'Image recognition',
  imageWholeNote: 'Image recognition',
  imageRule: 'Regular image annotation',
  imageRuleNote: 'Use regular graphs (rectangles, circles, etc.) to annotate the image.',
  imageIrregular: 'Irregular image recognition',
  imageIrregularNote: 'Use irregular graphics (polygons, points, etc.) to annotate in the image.',
  textTranslate: 'Text translation',
  textTranslateNote: 'Translate from one language to the other',
  textCouplet: 'Dialogue',
  textCoupletNote: 'Make up questions and answers',
  textTags: 'part-of-speech tagging',
  textTagsNote: 'Sentence segmentation and part of speech tagging',
  textAnalysis: 'Public opinion analysis',
  textAnalysisNote: ' 对文本进行词性、专有名词、修饰关系等标注',
  creatBtn: 'Create a task',
  taskImg: 'Preview template',
  contact: 'This project is under developing, please contact us if necessary.',
  mail: 'Email: fanhan@fanhantech.com',
  phone: 'Telephone: 0086512-6813-8573',
  js: {
    contact: '<p> This project is under developing, please contact us if necessary. </p><p>Email: fanhan@fanhantech.com</p><p>Telephone: 0086512-6813-8573</p>',
    developing: 'Task -- developing',
    template: 'Template',
    please: 'Please enter task name',
    creating: 'You are creating task -- ',
    true: 'Confirm',
    cancel: 'Cancellation',
    validator: 'Only to fill in letters, Chinese characters, numbers, and underlines.',
    successNote: 'New task success',
    cancelNote: 'Cancel the entry'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/selectProjectType.js